import "./HeaderHero.scss";
import bmwLogoWhite from "../../assets/bmwLogo_white.webp";

const HeaderHero = ({
  title = "CHOOSE YOUR PACKAGES",
  subtitle = "Select your desired media budgets and packages.",
  disclaimer = "",
  alwaysOnPackageError = true
}) => {
  return (
    <div className="form-hero-container">
      <div className="logo-container-wrapper">
        <div className="logo-container">
          <div className="logo-text">
            <p>BMW WESTERN REGION</p>
            <p>2026 TIER 3 DIGITAL PROGRAMS </p>
          </div>
          <img src={bmwLogoWhite} alt="BMW Logo" className="bmw-logo" />
        </div>
      </div>
      <div className="header-hero-content">
        <h1>{title}</h1>
        <p>{subtitle}</p>
        {disclaimer && (
          <div className="header-hero-disclaimer">
            <p>{disclaimer}</p>
          </div>
        )}

      </div>
    </div>
  );
};

export default HeaderHero;
